import { createContext, useContext } from 'react';
export const PropertiesCardContext = /*#__PURE__*/createContext(undefined);
export const usePropertiesCardContext = () => {
  const context = useContext(PropertiesCardContext);
  if (!context) {
    throw new Error('PropertiesCardContext is empty or not found');
  }
  return context;
};